import type React from 'react';
import classNames from 'classnames';

import CheckboxIcon from './checkbox-icon';
import RadioIcon from './radio-icon';

import { QUESTION_TYPES } from 'containers/admin/clients/client/tabs-components/ai-assistant/ai-assistant.constants';

interface GuidedPromptOptionProps {
  label: string;
  questionType: string;
  isSelected: boolean;
  onSelect?: (label: string) => void;
}

const GuidedPromptOption = ({
  label,
  questionType,
  isSelected,
  onSelect,
}: GuidedPromptOptionProps): React.JSX.Element => {
  const isMulti = questionType === QUESTION_TYPES.MULTI_SELECT;

  return (
    <button
      type="button"
      role={isMulti ? 'checkbox' : 'radio'}
      aria-checked={isSelected}
      aria-label={label}
      onClick={() => onSelect?.(label)}
      className={classNames(
        'w-full flex items-center gap-3 px-3.5 py-3 rounded-md text-sm text-left font-normal cursor-pointer transition-colors duration-100',
        isSelected
          ? 'bg-navy-50 border-2 border-navy-600 text-navy-700 font-medium'
          : 'bg-white border border-gray-200 text-gray-700 hover:bg-navy-50 hover:border-navy-300'
      )}
    >
      <span
        aria-hidden="true"
        className="flex-shrink-0 flex items-center justify-center"
      >
        {isMulti ? (
          <CheckboxIcon isSelected={isSelected} />
        ) : (
          <RadioIcon isSelected={isSelected} />
        )}
      </span>
      <span className="flex-1 leading-5">{label}</span>
    </button>
  );
};

export default GuidedPromptOption;
